const experiences = [
    {
      title: 'Associate L1 Developer',
      company: 'Infotact Solutions', 
      duration: 'Present',
      startDate: new Date('2025-05-25'),
      endDate: new Date(), // Current date for ongoing experience
      description: '',
      logoUrl: "white.png", 
      
    },
    {
      title: 'System Engineer',
      company: 'TCS', 
      duration: 'Present',
      startDate: new Date('2025-07-24'),
      endDate: new Date(), // Current date for ongoing experience
      description: '',
      logoUrl: "tcs.jpg", 
      
    },
    {
      title: 'Core Comitee Member',
      company: 'TAG Club VIT',
      duration: 'Jan 2023 - Apr 2025',
      startDate: new Date('2023-01-01'),
      endDate: new Date('2025-04-30'),
      description: 'Pioneered the TAG Projects initiative, resulting in a {40%} increase in member engagement in design, web development, and game development projects.',
      logoUrl: "tag.jpg",
      faq: [
        { question: 'Technologies used?', answer: 'React, Node.js, MongoDB, CSS, HTML, JavaScript, MERN, NEXT.js, MOngoDB' },
        { question: 'What was the biggest challenge?', answer: 'Ensuring cross-browser compatibility and optimizing performance.' },
      ],
    },
    {
      title: 'Technical Lead',
      company: 'Pixelate.',
      duration: 'Dec 2022 - Nov 2023',
      startDate: new Date('2022-12-01'),
      endDate: new Date('2023-11-30'),
      description: 'Led a project focused on creating diverse UI and UX designs for posts on LinkedIn to enhance the visibility and engagement of the Pixelate club page.',
      logoUrl: "pix.jpg", 
      faq: [
        { question: 'Project worked on?', answer: 'Worked on wide range of design projects spanning different mediums and disciplines, including graphic design, web design, UI/UX design, illustration, animation, digital art, and more. These projects may involve creating visual assets, designing user interfaces, crafting branding materials, or developing multimedia content..' },
        { question: 'Technologies used?', answer: 'Photoshop, Figma, Framer, AI, Ui/Ux Tools.' },
      ],
    },
    
  ];

  // Sort experiences by startDate in descending order (most recent first)
  const sortedExperiences = [...experiences].sort((a, b) => b.startDate - a.startDate);

  export default sortedExperiences;